import { trackEvent } from "@/lib/analytics";

export const BRAND = {
  name: "Unicorn Valley Group",
  short: "Unicorn Valley",
  tagline: "China Sourcing & Global Trade, Done Right",
  logo: "/logo.png",
  email: "info@unicornvalleygroup.com",
  phone: "+86 187 4002 6018",
  whatsapp: "8618740026018",
};

export const WHATSAPP_LINK = `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(
  "Hi Unicorn Valley Group, I'd like help with sourcing/importing from China."
)}`;

// Robust WhatsApp opener: tries a new tab, falls back to top-level navigation
// (covers sandboxed iframes / popup blockers where target="_blank" is ignored).
export function openWhatsApp(e) {
  if (e && e.preventDefault) e.preventDefault();
  trackEvent("whatsapp_click", { link_url: WHATSAPP_LINK, page_path: window.location.pathname });
  let win = null;
  try {
    win = window.open(WHATSAPP_LINK, "_blank", "noopener,noreferrer");
  } catch (_) {
    win = null;
  }
  if (!win) {
    try {
      window.top.location.href = WHATSAPP_LINK;
    } catch (_) {
      window.location.href = WHATSAPP_LINK;
    }
  }
}

export const NAV_LINKS = [
  { key: "services", to: "/services" },
  { key: "industries", to: "/industries" },
  { key: "products", to: "/products" },
  { key: "startBrand", to: "/start-your-brand" },
  { key: "blog", to: "/blog" },
  { key: "caseStudies", to: "/case-studies" },
  { key: "tools", to: "/tools" },
  { key: "about", to: "/about" },
];

export const TRUST_BADGES = [
  { icon: "ShieldCheck", key: "verifiedManufacturers" },
  { icon: "Lock", key: "securePayments" },
  { icon: "Boat", key: "doorToDoor" },
  { icon: "SealCheck", key: "qa" },
];

export const HOW_IT_WORKS = [
  { step: "01", key: "s1", icon: "ChatText" },
  { step: "02", key: "s2", icon: "MagnifyingGlass" },
  { step: "03", key: "s3", icon: "Checks" },
  { step: "04", key: "s4", icon: "Truck" },
];

export const GRADIENT = "bg-gradient-to-r from-[#1E73BE] to-[#16B894]";
export const GRADIENT_BR = "bg-gradient-to-br from-[#1E73BE] to-[#16B894]";

// Social profiles — update these URLs to the brand's real handles.
export const SOCIALS = [
  { key: "instagram", url: "https://instagram.com/unicornvalleygroup" },
  { key: "facebook", url: "https://facebook.com/unicornvalleygroup" },
  { key: "linkedin", url: "https://linkedin.com/company/unicornvalleygroup" },
  { key: "tiktok", url: "https://tiktok.com/@unicornvalleygroup" },
  { key: "twitter", url: "https://twitter.com/unicornvalleygrp" },
];
